import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {generateRoutePath} from 'epic-common/src/route';
import Message from '../../components/message/Message';

export default class NewsSection extends React.PureComponent {
    static propTypes = {
        recentBlogs: PropTypes.array.isRequired,
        newsTitle: PropTypes.string.isRequired
    };

    generateBlogList() {
        const {recentBlogs} = this.props;
        return recentBlogs.map((crtElement, index) => {
            const url = generateRoutePath(`news/${crtElement.slug}`);
            return (
                <div className="news-item" key={`bloglist-${crtElement.slug}`}>
                    <Link to={url}>
                        <div className="new-img-placeholder col l3 m3 s12" style={{background: `url(${crtElement.image}) no-repeat`}} />
                    </Link>
                    <div className="news-info col l9 m9 s12">
                        <h3 className="newsTitle"><Link to={url}>{crtElement.title}</Link></h3>
                        <div dangerouslySetInnerHTML={{__html: crtElement.short}} />
                        <p className="readMore">
                            <Link to={url}>
                                <Message code="epic.battlebreakers.news.read.more" />
                            </Link>
                        </p>
                    </div>
                </div>
            );
        });
    }
    render() {
        const blogList = this.generateBlogList();
        const {newsTitle} = this.props;
        return (
            <section className="news no-mar-bot">
                <div className="grid row">
                    <div className="latest-news col l12">
                        <p className="titlePanel">{newsTitle}</p>
                        <div className="content">
                            <div id="newsContainer">
                                {blogList}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
